import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Forside from "./pages/Forside";
import Clairvoyance from "./pages/Clairvoyance";
import Hypnose from "./pages/Hypnose";
import Butik from "./pages/Butik";
import DynamicPage from "./pages/DynamicPage";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

export default function App() {
  return (
    <HelmetProvider>
      <div className="relative min-h-screen flex flex-col bg-neutral-950 text-neutral-100 antialiased selection:bg-brand-500/30 selection:text-white">
        {/* Ambient background glow */}
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(184,142,61,0.05),transparent_50%)]" />
        
        {/* Scroll restoration */}
        <ScrollToTop />

        {/* Global Header */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow relative z-10">
          <Routes>
            {/* Static Pages */}
            <Route path="/" element={<Forside />} />
            <Route path="/clairvoyance" element={<Clairvoyance />} />
            <Route path="/clairvoyance-online" element={<Clairvoyance />} />
            <Route path="/hypnose" element={<Hypnose />} />
            <Route path="/butik" element={<Butik />} />
            
            {/* Error Pages */}
            <Route path="/403" element={<Forbidden />} />
            <Route path="/404" element={<NotFound />} />

            {/* Catch-all for other pages from CMS */}
            <Route path="/:slug" element={<DynamicPage />} />
            
            {/* Fallback to NotFound */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Global Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}
